import { useMemo } from 'react';
import {
  AttributeMappedWidgetDrawerContext,
  AttributeMappedWidgetDrawerProps,
} from './AttributeMappedWidgetDrawerContext';
import { useDocumentFootnotes } from '../../../context/DocumentFootnotesContext';
import WidgetDrawer from '../widget-drawer/WidgetDrawer';

export const AttributeMappedWidgetDrawer = (props: AttributeMappedWidgetDrawerProps) => {
  const { footnotes, documentSourceMap } = useDocumentFootnotes();

  const documentSourceProps = useMemo(
    () => ({
      documentCitations: footnotes,
      documentMetadata: documentSourceMap,
    }),
    [footnotes, documentSourceMap]
  );

  const contextProps = useMemo(() => {
    const {
      attributeMapper,
      attributeReferenceConfig,
      handlePushingAttributeMappings,
      handleClearMappings,
      onCitationPushed,
      onReprocessDocument,
    } = props;

    return {
      attributeMapper,
      attributeReferenceConfig,
      handlePushingAttributeMappings,
      handleClearMappings,
      onCitationPushed,
      onReprocessDocument,
    };
  }, [props]);

  return (
    <AttributeMappedWidgetDrawerContext.Provider value={contextProps}>
      <WidgetDrawer
        applicationContext={props.applicationContext}
        documentReferencesProps={props.documentReferencesProps}
        documentSourceProps={documentSourceProps}
        notesProps={props.notesProps}
        spreadsheetNotesProps={props.spreadsheetNotesProps}
        documentTabCustomActions={props.documentTabCustomActions}
        documentApplicationStorageKey={props.documentApplicationStorageKey}
      />
    </AttributeMappedWidgetDrawerContext.Provider>
  );
};
